import React from 'react';
import { UseFormRegister } from 'react-hook-form';

interface CrewCertificateFormData {
  certificateFile?: FileList;
  [key: string]: any;
}

interface DocumentFileUploadProps {
  register: UseFormRegister<CrewCertificateFormData>;
  selectedFileName: string;
  onFileChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

const DocumentFileUpload: React.FC<DocumentFileUploadProps> = ({
  register,
  selectedFileName,
  onFileChange,
}) => {
  return (
    <div className="px-4 py-4 flex items-center justify-between">
      <div className="w-1/3">
        <label className="text-sm font-medium text-gray-700">Document File (ملف الوثيقة)</label>
      </div>
      <div className="w-2/3">
        <div className="flex items-center justify-center w-full">
          <label className="flex flex-col items-center justify-center w-full h-32 border-2 border-gray-300 border-dashed rounded-lg cursor-pointer bg-gray-50 hover:bg-gray-100 transition-colors">
            <div className="flex flex-col items-center justify-center pt-5 pb-6">
              {selectedFileName ? (
                <>
                  <svg className="w-8 h-8 mb-2 text-green-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                  </svg>
                  <p className="mb-1 text-sm text-gray-700 font-medium">{selectedFileName}</p>
                  <p className="text-xs text-gray-500">Click to change file</p>
                </>
              ) : (
                <>
                  <svg className="w-8 h-8 mb-2 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12" />
                  </svg>
                  <p className="mb-1 text-sm text-gray-500">
                    <span className="font-semibold">Click to upload</span> or drag and drop
                  </p>
                  <p className="text-xs text-gray-500">PDF, PNG, JPG or JPEG (Max 10MB)</p>
                </>
              )}
            </div>
            <input
              type="file"
              {...register('certificateFile')}
              accept=".pdf,.png,.jpg,.jpeg"
              className="hidden"
              onChange={onFileChange}
            />
          </label>
        </div>
      </div>
    </div>
  );
};

export default DocumentFileUpload;
